import { formatCompact, formatCurrency } from '../../lib/format';
import type { CoinDetailSnapshot } from '../../types/market';
import { Badge } from '../ui/Badge';
import { Panel } from '../ui/Panel';

export function FundamentalsPanel({ detail }: { detail: CoinDetailSnapshot }): React.JSX.Element {
  const fundamentals = detail.fundamentals;
  const circulatingRatio = fundamentals.circulatingSupply && fundamentals.maxSupply
    ? (fundamentals.circulatingSupply / fundamentals.maxSupply) * 100
    : undefined;
  return (
    <Panel
      title="Coin information"
      description="Instant fundamentals with visible source confidence; unavailable data is never invented."
      action={<Badge tone={fundamentals.confidence === 'high' ? 'positive' : fundamentals.confidence === 'unavailable' ? 'warning' : 'info'}>{fundamentals.confidence}</Badge>}
    >
      <dl className="info-list">
        <div className="info-row"><dt>Asset</dt><dd>{fundamentals.name ?? detail.baseAsset}</dd></div>
        <div className="info-row"><dt>Market cap</dt><dd>{formatCurrency(fundamentals.marketCap)}</dd></div>
        <div className="info-row"><dt>Fully diluted value</dt><dd>{formatCurrency(fundamentals.fullyDilutedValue)}</dd></div>
        <div className="info-row"><dt>Circulating supply</dt><dd>{formatCompact(fundamentals.circulatingSupply)}</dd></div>
        <div className="info-row"><dt>Total supply</dt><dd>{formatCompact(fundamentals.totalSupply)}</dd></div>
        <div className="info-row"><dt>Maximum supply</dt><dd>{formatCompact(fundamentals.maxSupply)}</dd></div>
        <div className="info-row"><dt>Circulating / max</dt><dd>{circulatingRatio === undefined ? 'Unavailable' : `${circulatingRatio.toFixed(1)}%`}</dd></div>
        <div className="info-row"><dt>Source</dt><dd>{fundamentals.source}</dd></div>
      </dl>
    </Panel>
  );
}
